import { MAX_SOURCE_SUGGESTIONS } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/internal/consts.js';
import { getQueryToSearch, queryIncludesWholeWord, } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/internal/getQueryToSearch.js';
import { useSourceSuggestionKeywords } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/hooks/useSourceSuggestionKeywords.js';
import { useSources } from '#pplx/frontend/apps/ask/sources/hooks/useSources.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useMemo } from 'react';
export const useQuerySourceSuggestionsByKeyword = ({ query, maxSuggestions = MAX_SOURCE_SUGGESTIONS, omittedSources = EMPTY_ARRAY, omitCometMcpSources = false, enabled, productSurface, }) => {
    const { keywords } = useSourceSuggestionKeywords();
    const { sources: allowedSources, isSourceConnected } = useSources({
        enabled,
        omitCometMcpSources,
        omittedSources,
        productSurface,
    });
    const queryToSearch = getQueryToSearch(query);
    const suggestions = useMemo(() => {
        const result = new Map();
        for (const [keyword, sources] of keywords) {
            if (result.size >= maxSuggestions) {
                break;
            }
            if (!queryIncludesWholeWord(queryToSearch, keyword.toLowerCase())) {
                continue;
            }
            for (const source of sources) {
                if (result.size >= maxSuggestions) {
                    break;
                }
                if (!allowedSources.includes(source)) {
                    continue;
                }
                result.set(source, { source, connected: isSourceConnected(source) });
            }
        }
        return Array.from(result.values());
    }, [keywords, queryToSearch, maxSuggestions, allowedSources, isSourceConnected]);
    return useMemo(() => ({ suggestions }), [suggestions]);
};
//# sourceMappingURL=useQuerySourceSuggestionsByKeyword.js.map